import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./StandardDetail.scss";

function StandardDetail() {
  let navigate = useNavigate();
  const [detailInfo, setDetailInfo] = useState([]);
  const [createAtInfo, setCreateAtInfo] = useState(""); // 작성일 State 타입을 문자열로 미리 할당(undefined 방지)
  const [addFile, setAddFile] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    axios.get(`/api/examguide/${id}`).then((response) => {
      setDetailInfo(response.data);
      setCreateAtInfo(response.data.updateAt);
      setAddFile(response.data.docs);
    });
  }, [id]);
  return (
    <div>
      <div>
        <div className="notice_title_wrap">
          <h1 className="notice_title">
            {detailInfo.name}
            <p className="pubic_info">
              <span>
                <strong>심사기준번호: {detailInfo.manageNum}</strong>
              </span>
              <span>{createAtInfo.substring(0, 11).replace(/-/g, ".")}</span>
              <span>{detailInfo.writer}</span>
            </p>
          </h1>
        </div>
        <div className="notice_add_file_area">
          <div className="notice_add_file_wrap">
            <h2>첨부파일</h2>
            <div className="notice_addfile_wrap">
              {addFile.map((docs) => {
                return (
                  <a
                    href={`/api/examguide/${id}/doc-down/${docs.id}`}
                    key={docs.id}
                    download
                  >
                    {docs.name}
                  </a>
                  // <Link
                  //   to={`/api/board/${id}/document/${docs.id}}`}
                  //   target="_blank"
                  //   key={docs.id}
                  //   download
                  // >
                  //   <span>{docs.name}</span>
                  // </Link>
                );
              })}
            </div>
          </div>
          <div className="notice_content_row">
            <div
              className="jodit-wysiwyg"
              dangerouslySetInnerHTML={{ __html: detailInfo.description }}
            ></div>
            <div style={{ textAlign: "end" }}>
              <button
                className="btn_color"
                type="button"
                onClick={() => navigate("/standard")}
              >
                게시글 닫기
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default StandardDetail;
